export default "__VITE_ASSET__157a7f30__"